import { connect } from 'react-redux';
import { translate } from 'react-multi-lang';
import { InputAdornment } from '@mui/material';
import React, { useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import configuration from '../../utils/configuration';
import { getLoginAsset, getSiteLogo, getSiteName } from '../../utils/brandingConfig';

import GoogleLogin from './SocialLogin/GoogleLogin';
import ForgotPasswordModal from '../../components/Modals/ForgotPasswordModal';
import { googleSignInStart, userLoginStart } from '../../store/actions/UserAction';

import Blogs from './Blogs/Blogs';
import BannerAds from './Ads/BannerAds';
import TextFieldAuth from '../Input/TextFieldAuth';
import Testimonials from './Testimonials/Testimonials';
import CommunityPerformers from './CommunityPerformers/CommunityPerformers';

import './Login.scss';
import '../../main.css';
import '../Search/style.css'

function Login({ setShow, ...props }) {
  const navigate = useNavigate();
  const siteName = getSiteName();
  const logoDark = getSiteLogo({ isDark: true });

  const videoRef = useRef();
  const videoRefAcc = useRef();

  const [open, setOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPlayingAcc, setIsPlayingAcc] = useState(false);
  const [loginInputData, setLoginInputData] = useState({});
  const [isProcessed, setIsProcessed] = useState({
    viewProfile: false,
    joinNow: false,
    freeAccount: false
  })

  const handleLogin = (event) => {
    event.preventDefault();
    props.dispatch(userLoginStart(loginInputData));
  };

  const handleGoogleLogin = (data) => {
    props.dispatch(googleSignInStart({
      code: data.code
    }));
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <ForgotPasswordModal
        setShow={setShow}
        open={open}
        onClose={handleClose}
      />
      <div className='login-banner-section'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-xl-6'>
              <div className='banner-images-box'>
                <div className='login-banner-details mx-auto'>
                  <img src={logoDark} className='logo-img' alt={siteName} />
                  <h1 className='intro-title'>THE PREMIER <span style={{}}>PERFORMER-FAN</span> PORTAL</h1>
                  <hr className='hr-border' />
                  <div>
                    <div className='user-type-wrapper'>
                      <span>
                        Performers
                      </span>
                    </div>
                    <ul className='w-90 mx-auto my-2 custPadding'>
                      <li>interact with your fans and make money </li>
                      <li>Exclusive contents</li>
                      <li>VIP rooms</li>
                      <li>paid private messaging</li>
                      <li>best-in-class security</li>
                    </ul>
                  </div>
                  <div>
                    <div className='user-type-wrapper'>
                      <span>Fans
                      </span>
                    </div>
                    <ul className='w-90 mx-auto my-2 custPadding'>
                      <li>
                        get direct access to your favourite performer
                      </li>
                    </ul>
                  </div>
                  <hr className='hr_margin' />
                </div>
                <img
                  src={getLoginAsset('ipad')}
                  className='ipad-img d-xl-inline-block d-none'
                  alt='iPad'
                />
              </div>
            </div>
            <div className='col-xl-6'>
              {/* <img src={details} className='details-img' alt='icon' /> */}
              <div className='login-box login-form'>
                <form
                  onSubmit={handleLogin}
                  id='form'
                  method='post'
                  name='form'
                  autoComplete='off'
                  translate='no'
                >
                  <div className='mb-4 box mt-3'>
                    <TextFieldAuth
                      className='mb-3 w-100 email-box border-8'
                      id='email'
                      label='Email'
                      variant='outlined'
                      value={loginInputData.email}
                      data-test='email'
                      classes={{
                        root: 'input-root',
                      }}
                      onChange={(event) =>
                        setLoginInputData({
                          ...loginInputData,
                          email: event.currentTarget.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className='mb-3 mt-1'>
                    <TextFieldAuth
                      data-test='password'
                      type='password'
                      label='Password'
                      placeholder='Password'
                      id='password'
                      value={loginInputData.password}
                      classes={{
                        root: 'input-root',
                      }}
                      onChange={(event) =>
                        setLoginInputData({
                          ...loginInputData,
                          password: event.currentTarget.value,
                        })
                      }
                      required
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position='end'>
                            <i
                              className='far fa-eye white'
                              id='togglePassword'
                              data
                              onClick={(e) => {
                                const togglePassword =
                                  document.querySelector('#togglePassword');
                                const password =
                                  document.querySelector('#password');
                                const type =
                                  password.getAttribute('type') === 'password'
                                    ? 'text'
                                    : 'password';
                                password.setAttribute('type', type);
                                togglePassword.classList.toggle('fa-eye-slash');
                              }}
                            ></i>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className='mb-4 form-check d-flex justify-content-between'>
                    <span className='float-left'>
                      <input
                        data-test='remember'
                        type='checkbox'
                        className='form-check-input'
                        id='remember'
                      />
                      <label className='form-check-label white'>Remember Me</label>
                    </span>
                    <span
                      className='float-right white'
                      role='button'
                      onClick={handleOpen}
                      aria-label='forgot password'
                    >
                      Forgot Password ?
                    </span>
                  </div>
                  <button
                    id='login'
                    onClick={handleLogin}
                    type='submit'
                    data-test='login-button'
                    className='btn login btn-loading w-100'
                    disabled={props.googleSignIn.loading}
                    title='login'
                  >
                    <div>
                      {props?.login?.loading && <div className='btn-spinner' />}
                    </div>
                    Log in
                  </button>
                  <p className='help-text text-center mb-0'>
                    Visit the <span onClick={() => navigate('/help-and-support')}>help center</span> for assistance, if you are
                    unable to login <br />
                  </p>
                  <div className='loginwith-box'>
                    <div className='or-loginwith'>
                      <span>OR</span>
                    </div>

                    {!navigator.userAgent.includes('FB_IAB') &&
                      !navigator.userAgent.includes('Instagram') &&
                      !navigator.userAgent.includes('TikTok') && (
                        <GoogleLogin
                          className='btn login'
                          onLoginSuccess={handleGoogleLogin}
                          onLoginFailure={(err) => {
                            console.log('err', err);
                          }}
                          loading={props.googleSignIn.loading}
                        />
                      )}

                    <p className='text-center mt-3 mb-0 white'>
                      Don’t have an account?{' '}
                      <Link
                        className='login-link a'
                        to='/registers'
                        id='signup'
                        aria-label='navigate to signUp'
                        data-test='register'
                        onMouseDown={(event) => {
                          event.preventDefault();
                          window.scrollTo(0, 0);
                          navigate('/register');
                        }}
                      >
                        REGISTER NOW
                      </Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='introduction-main'>
        <div className='container'>
          <div className='heading-box text-center'>
            <div className='section-title'>INTRODUCTION</div>
            <h2 className='heading-title'>How It Works?</h2>
          </div>
          <div className='mx-5 row'>
            <div className='col-md-4 mb-4 text-center'>
              <img src={getLoginAsset('communityIcon')} className='work-icon' alt='icon' />
              <p className='work-title'>Build a Community</p>
              <p className='work-sub'>
                {' '}
                Connect with your followers and fans in a meaningful way and
                grow your audience.
              </p>
            </div>
            <div className='col-md-4 mb-4 text-center'>
              <img src={getLoginAsset('onlineIncomeIcon')} className='work-icon' alt='icon' />
              <p className='work-title'>Boost Online Income</p>
              <p className='work-sub'>
                Create unique content your fans know they can’t find anywhere
                else.
              </p>
            </div>
            <div className='col-md-4 mb-4 text-center'>
              <img src={getLoginAsset('startIncomeIcon')} className='work-icon' alt='icon' />
              <p className='work-title'>Built for Entrepreneurs</p>
              <p className='work-sub'>
                Leverage your inventiveness to create a thriving business and
                sustainable income.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='about-bg'>
        <div className='container'>
          <div className='about-inner-bg'>
            <div className='row'>
              <div className='col-md-6 order-md-2'>
                <div className='video-box'>
                  {!isPlaying && (
                    <span className='playbtn'>
                      <img
                        src={getLoginAsset('playNew')}
                        alt='play_icon'
                        onClick={() => {
                          videoRef.current.play();
                          setIsPlaying(true);
                        }}
                      />
                    </span>
                  )}
                  <img
                    src={getLoginAsset('defaultVideo')}
                    className={!isPlaying ? 'video' : 'video d-none'}
                    alt='video image'
                  />
                  <video
                    id='about'
                    ref={videoRef}
                    src={configuration.get('configData.landing_page_video_1')}
                    className={isPlaying ? 'video' : 'video d-none'}
                    controls={true}
                    onEnded={() => {
                      setIsPlaying(false);
                    }}
                  />
                </div>
              </div>
              <div className='col-md-6 order-md-1 pt-4 py-md-3'>
                <div className='section-title'>ABOUT US</div>
                <div className='heading-title'>What Is {siteName}?</div>
                <p className='about-disc'>
                  {' '}
                  {siteName} is a premium social media fan club that enables
                  influencers, creators, artists, public figures, and all types
                  of compelling people to interact with and share various forms
                  of original content with their most loyal fans. Fans can
                  support their favorite creators and access exclusive content
                  and benefits via {siteName}, creating the opportunity to
                  turn individual ingenuity and influence into a thriving
                  business.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {configuration.get('configData.landing_page_ads') == '1' && <BannerAds />}

      <CommunityPerformers
        isProcessed={isProcessed}
        setIsProcessed={setIsProcessed} />

      <div className='get-started-bg '>
        <div className='container'>
          <div className='get-started-inner-bg'>
            <div className='heading-box text-center pb-0'>
              <img src={getLoginAsset('icon')} className='icon-img' alt='icon' />
              <div className='section-title'>GET STARTED</div>
              <div className='heading-title'>Start Interacting Today!</div>
              <div className='details-sub'>
                {siteName} is the premier social platform for connecting
                performers with fans.
              </div>
              <div className='details-sub1'>
                “Bringing catered social interaction to your screen' is the
                foundation of what makes {siteName} different. You will not be
                hindered in your pursuit to present or enjoy content on our
                platform, allowing you to have fun and enjoy being yourself.
              </div>
            </div>
            <div className='start-interacting-block'>
              <div className='row'>
                <div className='col-lg-3 col-6 mt-md-4 mb-4 text-center'>
                  <img src={getLoginAsset('trophy')} className='dating-img' alt='icon' />
                  <p className='icon-desc'>
                    Best Adult Friendly Social Platform
                  </p>
                </div>
                <div className='col-lg-3 col-6 mt-md-4 mb-4 text-center'>
                  <img src={getLoginAsset('secured')} className='dating-img' alt='icon' />
                  <p className='icon-desc'>Secured and Private Interactions</p>
                </div>
                <div className='col-lg-3 col-6 mt-md-4 mb-4 text-center'>
                  <img src={getLoginAsset('heart')} className='dating-img' alt='icon' />
                  <p className='icon-desc'>Top Tier Performer Connections</p>
                </div>
                <div className='col-lg-3 col-6 mt-md-4 mb-4 text-center'>
                  <img src={getLoginAsset('worldwide')} className='dating-img' alt='icon' />
                  <p className='icon-desc'>
                    Search The Best Creators Worldwide
                  </p>
                </div>
              </div>
            </div>
            <div className='text-center align-items-center'>
              <button
                className='btn login btn-loading join-now'
                onClick={(event) => {
                  setIsProcessed({
                    ...isProcessed,
                    joinNow: true
                  })
                  setTimeout(() => {
                    event.preventDefault();
                    window.scrollTo(0, 0);
                    navigate('/register');
                  }, 10)
                }}
              >
                <div>
                  {isProcessed.freeAccount ? 'Loading' : 'JOIN NOW'}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonails Section */}
      <Testimonials />

      {/* Blogs Section */}
      {/* <Blogs /> */} {/* Temporarily hidden */}
      
      <div className='create-acc-bg'>
        <div className='container'>
          <div className='create-acc-inner-bg'>
            <div className='row'>
              <div className='col-md-6'>
                <div className='video-box create-acc-video'>
                  {!isPlayingAcc && (
                    <span className='playbtn'>
                      <img
                        src={getLoginAsset('playNew')}
                        alt='play_icon'
                        onClick={() => {
                          videoRefAcc.current.play();
                          setIsPlayingAcc(true);
                        }}
                      />
                    </span>
                  )}
                  <img
                    src={getLoginAsset('defaultVideo')}
                    className={!isPlayingAcc ? 'video' : 'video d-none'}
                    alt='video image'
                  />
                  <video
                    id='create-account'
                    src={configuration.get('configData.landing_page_video_2')}
                    ref={videoRefAcc}
                    className={isPlayingAcc ? 'video' : 'video d-none'}
                    controls={true}
                    onEnded={() => {
                      setIsPlayingAcc(false);
                    }}
                  />
                </div>
              </div>
              <div className='col-md-6 pt-4 pt-md-0 ps-4 m-auto'>
                <div className='text-left'>
                  <img src={getLoginAsset('icon2')} className='icon-img' alt='icon' />
                  <div className='section-title'>Create an Account</div>
                  <div className='heading-title'>
                    Get Started With {siteName}
                  </div>
                  <button
                    className='btn login btn-loading px-sm-5 px-2 mt-3 reg-btn '
                    data-test='create-account'
                    onClick={(event) => {
                      setIsProcessed({
                        ...isProcessed,
                        freeAccount: true
                      })
                      setTimeout(() => {
                        event.preventDefault();
                        window.scrollTo(0, 0);
                        navigate('/register');
                      }, 10)
                    }}
                  >
                    <div>
                      {isProcessed.freeAccount ? 'Loading' : 'CREATE FREE ACCOUNT'}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToPros = (state) => ({
  login: state.users.loginInputData,
  validation: state.users.validationInputData,
  googleSignIn: state.users.googleSignInData,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(translate(Login));

export { Login };
